import {takeLatest, call, put} from 'redux-saga/effects';
import * as ticketsService from '../api/loginService';

export function* loginAuth(action) {
    const {data} = yield call(ticketsService.loginAuth, action.values);
    yield put({type: "LOGGEDIN_REQUEST_SUCCESS", data});

}